import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Table from '../../components/Common/Table';
import Button from '../../components/Common/Button';
import api from '../../utils/api';
import { Plus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { usePermission } from '../../hooks/usePermission';

const DepartmentList = () => {
  const { user } = useAuth();
  const { canView, canCreate, canEdit, canDelete } = usePermission();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    if (!canView('departments')) {
      navigate('/');
      return;
    }

    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/departments');
      setDepartments(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Departmanlar yüklenemedi:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm(`"${row.name}" departmanını silmek istediğinizden emin misiniz?`)) {
      return;
    }

    try {
      await api.delete(`/departments/${row.id}`);
      fetchDepartments();
    } catch (error) {
      console.error('Departman silinemedi:', error);
      alert('Departman silinirken bir hata oluştu');
    }
  };

  const columns = [
    { header: 'Departman Adı', accessor: 'name' },
    {
      header: 'Personel Sayısı',
      accessor: 'users',
      render: (row) => row.users?.length || 0
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Yükleniyor...</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Departmanlar</h1>
        {canCreate('departments') && (
          <Button onClick={() => navigate('/departments/new')}>
            <Plus size={18} />
            Yeni Departman
          </Button>
        )}
      </div>

      <Card noPadding>
        <Table
          columns={columns}
          data={departments}
          onView={(row) => navigate(`/departments/${row.id}`)}
          onEdit={(row) => navigate(`/departments/${row.id}/edit`)}
          onDelete={handleDelete}
          canEdit={() => canEdit('departments')}
          canDelete={() => canDelete('departments')}
        />
      </Card>
    </div>
  );
};

export default DepartmentList;
